import { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
// import { useGetContactsQuery } from "../../../../store/api/contactapi";

import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";

import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const dummyContactsResponse = {
  data: [
    {
      name: "PCV-0001",
      Id: 101,
      Company: "Sales Account",
      DateTime: "2025-01-10 10:30:00",
      TemplateTitle: "Sales Journal Template",
      JournalEntryType: "Sales",
      status: "Active",
    },
    {
      name: "PCV-0002",
      Id: 102,
      Company: "Purchase Account",
      DateTime: "2024-06-15 14:20:00",
      TemplateTitle: "Purchase Journal Template",
      JournalEntryType: "Purchase",
      status: "Passive",
    },
    {
      name: "PCV-0003",
      Id: 103,
      Company: "Expense Account",
      DateTime: "2023-03-05 09:00:00",
      TemplateTitle: "Expense Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0004",
      Id: 104,
      Company: "Salary Account",
      DateTime: "2025-02-01 18:45:00",
      TemplateTitle: "Salary Journal Template",
      JournalEntryType: "Salary",
      status: "Passive",
    },
    {
      name: "PCV-0005",
      Id: 105,
      Company: "GST Payable",
      DateTime: "2024-11-22 11:10:00",
      TemplateTitle: "GST Journal Template",
      JournalEntryType: "Tax",
      status: "Active",
    },
    {
      name: "PCV-0006",
      Id: 106,
      Company: "Cash Account",
      DateTime: "2024-01-12 12:00:00",
      TemplateTitle: "Cash Journal Template",
      JournalEntryType: "Cash",
      status: "Active",
    },
    {
      name: "PCV-0007",
      Id: 107,
      Company: "Bank Account",
      DateTime: "2023-09-18 16:40:00",
      TemplateTitle: "Bank Journal Template",
      JournalEntryType: "Bank",
      status: "Passive",
    },
    {
      name: "PCV-0008",
      Id: 108,
      Company: "Vendor Payable",
      DateTime: "2025-03-02 09:15:00",
      TemplateTitle: "Vendor Journal Template",
      JournalEntryType: "Payable",
      status: "Active",
    },
    {
      name: "PCV-0009",
      Id: 109,
      Company: "Client Receivable",
      DateTime: "2024-07-09 17:30:00",
      TemplateTitle: "Client Journal Template",
      JournalEntryType: "Receivable",
      status: "Active",
    },
    {
      name: "PCV-0010",
      Id: 110,
      Company: "Maintenance Expense",
      DateTime: "2023-12-20 10:05:00",
      TemplateTitle: "Maintenance Journal Template",
      JournalEntryType: "Expense",
      status: "Passive",
    },
    {
      name: "PCV-0011",
      Id: 111,
      Company: "Travel Expense",
      DateTime: "2024-04-14 15:55:00",
      TemplateTitle: "Travel Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0012",
      Id: 112,
      Company: "Office Supplies",
      DateTime: "2025-05-01 11:25:00",
      TemplateTitle: "Office Supplies Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0013",
      Id: 113,
      Company: "Professional Fees",
      DateTime: "2023-08-07 13:40:00",
      TemplateTitle: "Professional Fees Template",
      JournalEntryType: "Expense",
      status: "Passive",
    },
    {
      name: "PCV-0014",
      Id: 114,
      Company: "Advertising Expense",
      DateTime: "2024-10-03 09:50:00",
      TemplateTitle: "Advertising Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0015",
      Id: 115,
      Company: "Rent Expense",
      DateTime: "2025-06-18 18:10:00",
      TemplateTitle: "Rent Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0016",
      Id: 116,
      Company: "Electricity Charges",
      DateTime: "2024-02-28 14:35:00",
      TemplateTitle: "Electricity Journal Template",
      JournalEntryType: "Utility",
      status: "Passive",
    },
    {
      name: "PCV-0017",
      Id: 117,
      Company: "Internet Charges",
      DateTime: "2023-11-11 10:00:00",
      TemplateTitle: "Internet Journal Template",
      JournalEntryType: "Utility",
      status: "Active",
    },
    {
      name: "PCV-0018",
      Id: 118,
      Company: "Telephone Expense",
      DateTime: "2024-08-22 16:45:00",
      TemplateTitle: "Telephone Journal Template",
      JournalEntryType: "Utility",
      status: "Active",
    },
    {
      name: "PCV-0019",
      Id: 119,
      Company: "Repair & Maintenance",
      DateTime: "2025-07-05 12:30:00",
      TemplateTitle: "Repair Journal Template",
      JournalEntryType: "Expense",
      status: "Passive",
    },
    {
      name: "PCV-0020",
      Id: 120,
      Company: "Insurance Expense",
      DateTime: "2024-09-30 09:20:00",
      TemplateTitle: "Insurance Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0021",
      Id: 121,
      Company: "Fuel Expense",
      DateTime: "2023-05-19 17:00:00",
      TemplateTitle: "Fuel Journal Template",
      JournalEntryType: "Expense",
      status: "Active",
    },
    {
      name: "PCV-0022",
      Id: 122,
      Company: "Commission Expense",
      DateTime: "2024-12-12 11:45:00",
      TemplateTitle: "Commission Journal Template",
      JournalEntryType: "Expense",
      status: "Passive",
    },
    {
      name: "PCV-0023",
      Id: 123,
      Company: "Bonus Account",
      DateTime: "2025-08-25 18:00:00",
      TemplateTitle: "Bonus Journal Template",
      JournalEntryType: "Salary",
      status: "Active",
    },
    {
      name: "PCV-0024",
      Id: 124,
      Company: "Miscellaneous Expense",
      DateTime: "2023-10-01 08:30:00",
      TemplateTitle: "Misc Journal Template",
      JournalEntryType: "Expense",
      status: "Passive",
    },
    {
      name: "PCV-0025",
      Id: 125,
      Company: "Capital Account",
      DateTime: "2024-03-16 15:10:00",
      TemplateTitle: "Capital Journal Template",
      JournalEntryType: "Capital",
      status: "Active",
    },
  ],
};



const MainList = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling , pageSize} = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showFilters, setShowFilters] = useState(false)
  //states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);
  const data = dummyContactsResponse;
const isLoading = false;
const refetchGetContact = () => {};
//   const { data, isLoading, refetch:refetchGetContact } = useGetContactsQuery();
  const contacts = data?.data || [];
  const [showExportPopup, setShowExportPopup] = useState(false);
  const contactsWithSiNo = contacts.map((item, index) => ({
    ...item,
    siNo: index + 1
  }));
  const filtersConfig = [
        {name: 'siNo', label: 'SI.No',type: 'number', width: '12%',gap:'0px', },
        { name: 'TemplateTitle', label: 'Template Title', type: 'text', width: '10%' },
        { name: 'Company', label: 'Company',type: 'text', width: '12%' },
        { name: 'DateTime', label: 'Date & Time', type: 'date', width: '10%' },   
        { name: 'JournalEntryType', label: 'Journal Entry Type', type: 'text', width: '10%' }, 
        {
            name: 'status',
            label: 'Status',
            width: '12%',
            type: 'select',
            options: [
                { value: 'pending', label: 'Pending' },
                { value: 'completed', label: 'Completed' },
                { value: 'cancelled', label: 'Cancelled' },
            ]
        },
    ];



  // 🔍 Apply filters
  const filteredContacts = useMemo(() => {
    return contactsWithSiNo.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const itemValue = item[key]?.toString().toLowerCase();
        if (key === "creation") return item[key]?.split(" ")[0] === value;
        if (key === "status") return item[key] === value;
        if (key === "siNo") return item.siNo.toString() === value.toString();
        return itemValue?.includes(value.toLowerCase());
      });
    });
  }, [contactsWithSiNo, filters]);

  // 3️⃣ Paginate after filtering
  const paginatedData = filteredContacts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  useEffect(() => {
    if (pageSize > 0) {
      refetchGetContact()
    };
    }, [pageSize,currentPage,screenHeight, screenScaling]);

  



  const handleView = (id) => {
    navigate("/Master/JournalEntry/Create-JournalEntry/AddJournalEntry");

   
  };

  const handleEdit = (id) => {
    
  };

  const handleDelete = (id) => {
    setDelSelectedId(id);
    setDelPopupVisible(true);
    setAlreadySubmitData(false);
    setDelmessage("Are you sure you want to Delete this Contact?");
};

const delHandleCancel = () => {
    setDelPopupVisible(false);
    setDelSelectedId(null);
};

const delHandleConfirm = async () => {
    try {
        await deleteDoc({
            doctype: "Contact",
            name: delSelectedId,
        }).unwrap();
        setDelmessage(`Contact ${delSelectedId} deleted successfully!`);
        setDelDone(true);
        setTimeout(() => {
            setDelPopupVisible(false);
            setDelSelectedId(null);
            setDelDone(false);
            refetchGetContact();
        }, 1000);
    } catch (err) {
        console.error("Deletion Failed:", err);

        let errorMessage = "Failed to delete the Contact!";

        //If the server is sending the error message , we will extract it.
        if (err?.data?._server_messages) {
            try {
                const messageArr = JSON.parse(err.data._server_messages);
                if (messageArr && messageArr.length > 0) {
                    //parse inner json object
                    const messageObj = JSON.parse(messageArr[0]);
                    if (messageObj?.message) {
                        //extract the exact message we want
                        const fullMessage = messageObj.message;
                        errorMessage = fullMessage.split("You must")[0].trim();
                        //remove html in the message
                        errorMessage = errorMessage.replace(/<[^>]+>/g, "");
                    }
                }
            } catch (parseError) {
                console.error("Error parsing server messages:", parseError);
            }
        }
        setDelPopupVisible(true);
        setDelmessage(errorMessage);
        setAlreadySubmitData(true);
    } finally {
        // setTimeout(() => {
        //     setDelPopupVisible(false);
        //     setDelSelectedId(null);
        // }, 2000);
    }
};



  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      width: "5%",
      cellRenderer: (row) => row.siNo,
      sortable: false,
      visible: true
    },
        {
      header: "Template Title",
      name: "TemplateTitle",
      accessor: "TemplateTitle",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.TemplateTitle?.split(" ")[0]
    },
    {
      header: "Company",
      name: "Company",
      accessor: "Company",
      width: "17.7%",
      sortable: false,
      visible: true

    },

        {
      header: "Date & Time",
      name: "Date&Time",
      accessor: "DateTime",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.DateTime?.split(" ")[0]
    },
          {
      header: "Journal Entry Type",
      name: "JournalEntryType",
      accessor: "JournalEntryType",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.JournalEntryType?.split(" ")[0]
    },
    {
      header: "Status",
      name: "Status",
      accessor: "status",
      width: "17.7%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => {
        const statusText = row.status === "Passive" ? "Passive" : row.status;
        const color = row.status === "Passive" ? "#16A34A" : "#EF4444";
        return <span style={{ color }}>{statusText}</span>;
      }
    },
    {
      header: "Action",
      name: "Action",
      accessor: "action",
      width: "10%",
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView()}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      )
    }
  ]);

  // Handle column configuration changes
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns)
  }
  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);


  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/Master/JournalEntryTemplate/Create-JournalEntryTemplate/CreateJournalEntryTemplate",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: " Add Journal Entry Template"
    }
  ];
    const accessors = columnsConfig
        .filter(column => column.accessor !== "siNo" && column.accessor !=="action")
        .map(column => column.accessor);

   return (
    <div className="container-fluid d-flex flex-column" style={{ flexGrow: "1" }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "Master" },
          { label: "Journal Entry Template List", style: { color: "#4b002b" } }
        ]}
        actionButtons={actionButtons}
      >
        {
          showFilters && (
            <ListFilters
              filtersConfig={filtersConfig}
              onFilterChange={handleFilterChange}
              currentFilters={filters}
              setShowFilters={setShowFilters}
            />
          )
        }

        {
          showColumnConfig && <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Contact"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "status", "action", "creation", "name"]}
          />
        }

        <Table columns={visibleColumns} data={paginatedData} loading={isLoading} />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={filteredContacts.length}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (        
          <DelConfirmPopup
            alredysubmitdata={alreadySubmitData}
            delSelectedId={delSelectedId}
            visible={delPopupVisible}
            message={delmessage}
            onConfirm={delHandleConfirm}
            onCancel={delHandleCancel}
            delDone={delDone}
          />
        )}
        {showExportPopup && (
          <ExportCSV
            doctype="Contact"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}
      </ListLayout>
    </div>
  );
};

export default MainList;
